<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
<!--          <b-row>-->
            <!-- .name -->
<!--            <b-col lg="6">-->
          <div class="row">
            <div class="col-md-12">
              <b-form-group
                  id="input-group-1"
                  :label="$t('form_data.name')"
                  label-for="input-1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="name"
                    vid="name"
                    rules="required"
                >
                  <b-form-input
                      id="input-1"
                      v-model="newItem.name"
                      type="text"
                      :placeholder="$t('form_data.name')"
                      :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>
          </div><hr />
          <div class="row">
            <div class="col-md-6">
              <b-form-group
                  id="input-group-1"
                  :label="$t('form_data.check_box')"
                  label-for="input-1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="name"
                    vid="name"
                    rules="required"
                >

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

                <div class="form-group" v-for="(checkbox,k) in newItem.mydata.checkboxs" :key="k">
                  <input type="text" class="form-control" v-model="checkbox.name">
                  <span>
                      <i class="fas fa-minus-circle" @click="removecheckboxs(k)" v-show="k || ( !k && newItem.mydata.checkboxs.length > 1)">حذف</i>
                      <i class="fas fa-plus-circle" @click="addcheckboxs(k)" v-show="k == newItem.mydata.checkboxs.length-1">المزيد</i>
                    </span>
                </div>
              </b-form-group>
            </div>
          </div><hr />
          <div class="row">
            <div class="col-md-6">
              <b-form-group
                  id="input-group-1"
                  :label="$t('form_data.text_input')"
                  label-for="input-1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="name"
                    vid="name"
                    rules="required"
                >

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

                <div class="form-group" v-for="(textbox,k) in newItem.mydata.textboxs" :key="k">
                  <input type="text" class="form-control" v-model="textbox.name">
                  <span>
                      <i class="fas fa-minus-circle" @click="removetextboxs(k)" v-show="k || ( !k && newItem.mydata.textboxs.length > 1)">حذف</i>
                      <i class="fas fa-plus-circle" @click="addtextboxs(k)" v-show="k == newItem.mydata.textboxs.length-1">المزيد</i>
                    </span>
                </div>
              </b-form-group>
            </div>
          </div><hr />
          <div class="row">
            <div class="col-md-6">
              <b-form-group
                  id="input-group-1"
                  :label="$t('form_data.radio_button')"
                  label-for="input-1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="name"
                    vid="name"
                    rules="required"
                >

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

                <div class="form-group" v-for="(radiobutton,k) in newItem.mydata.radiobuttons" :key="k">
                  <input type="text" class="form-control" v-model="radiobutton.name">
                  <span>
                      <i class="fas fa-minus-circle" @click="removeradiobuttons(k)" v-show="k || ( !k && newItem.mydata.radiobuttons.length > 1)">حذف</i>
                      <i class="fas fa-plus-circle" @click="addradiobuttons(k)" v-show="k == newItem.mydata.radiobuttons.length-1">المزيد</i>
                    </span>
                </div>
              </b-form-group>
            </div>
          </div><hr />
          <div class="row">
            <div class="col-md-6">
              <b-form-group
                  id="input-group-1"
                  :label="$t('form_data.text_area')"
                  label-for="input-1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="name"
                    vid="name"
                    rules="required"
                >

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

                <div class="form-group" v-for="(textarea,k) in newItem.mydata.textareas" :key="k">
                  <input type="text" class="form-control" v-model="textarea.name">
                  <span>
                      <i class="fas fa-minus-circle" @click="removetextareas(k)" v-show="k || ( !k && newItem.mydata.textareas.length > 1)">حذف</i>
                      <i class="fas fa-plus-circle" @click="addtextareas(k)" v-show="k == newItem.mydata.textareas.length-1">المزيد</i>
                    </span>
                </div>
              </b-form-group>
            </div>
          </div><hr />
          <div class="row">
            <div class="col-md-6">
              <b-form-group
                  id="input-group-1"
                  :label="$t('form_data.select_box')"
                  label-for="input-1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="name"
                    vid="name"
                    rules="required"
                >

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

                <div class="form-group" v-for="(selectbox,k) in newItem.mydata.selectboxs" :key="k">
                  <input type="text" class="form-control" v-model="selectbox.name">
                  <span>
                      <i class="fas fa-minus-circle" @click="removeselectboxs(k)" v-show="k || ( !k && newItem.mydata.selectboxs.length > 1)">حذف</i>
                      <i class="fas fa-plus-circle" @click="addselectboxs(k)" v-show="k == newItem.mydata.selectboxs.length-1">المزيد</i>
                    </span>
                </div>
              </b-form-group>
            </div>
          </div>


<!--            </b-col>-->
            <!-- .translations -->

<!--          </b-row>-->
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/FormDataController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  name: "FormDataForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      file: {},
      
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.newItem.data=this.newItem.mydata;
      // console.log(this.mydata);
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    addcheckboxs () {
      console.log(this.mydata);
      this.newItem.mydata.checkboxs.push({
        name: ''
      })
      console.log(this.newItem.mydata.checkboxs)
    },
    addtextboxs () {
      this.newItem.mydata.textboxs.push({
        name: ''
      })
      console.log(this.newItem.mydata.textboxs)
    },
    addradiobuttons () {
      this.newItem.mydata.radiobuttons.push({
        name: ''
      })
      console.log(this.newItem.mydata.radiobuttons)
    },
    addtextareas () {
      this.newItem.mydata.textareas.push({
        name: ''
      })
      console.log(this.newItem.mydata.textareas)
    },
    addselectboxs () {
      this.newItem.mydata.selectboxs.push({
        name: ''
      })
      console.log(this.newItem.mydata.selectboxs)
    },

    removecheckboxs (index) {
      this.newItem.mydata.checkboxs.splice(index, 1)
    },
    removetextboxs (index) {
      this.newItem.mydata.textboxs.splice(index, 1)
    },
    removeradiobuttons (index) {
      this.newItem.mydata.radiobuttons.splice(index, 1)
    },
    removetextareas (index) {
      this.newItem.mydata.textareas.splice(index, 1)
    },
    removeselectboxs (index) {
      this.newItem.mydata.selectboxs.splice(index, 1)
    },
  },
};
</script>

